// if there's .heading-reveal-container, use GSAP split text to reveal the heading word by word on scroll
const headingRevealContainer = document.querySelector('.heading-reveal-container')
if (headingRevealContainer) {
	gsap.registerPlugin(SplitText)
	const headingRevealText = headingRevealContainer.querySelector('.heading-reveal-copy')
	const headingRevealTextSplit = new SplitText(headingRevealText, {
		type: 'words',
	})
	const headingRevealTextSplitTL = gsap.timeline({
		scrollTrigger: {
			trigger: headingRevealContainer,
			start: 'top 75%',
			end: 'bottom 50%',
			scrub: 1,
		}
	})
	headingRevealTextSplitTL.from(headingRevealTextSplit.words, {
		opacity: 0.25,
		stagger: 0.1,
		ease: 'ease.inOut',
	})
}





const ourTeamGalleryContainer = document.querySelector('.our-team-gallery .gallery-container')
const ourTeamCategoryButtons = document.querySelectorAll('.our-team-gallery .category-button')
const ourTeamMemberCards = document.querySelectorAll('.our-team-gallery .member-card')
const ourTeamGallery = document.querySelector('.our-team-gallery')

const ITEMS_PER_PAGE = 12
const MOBILE_BREAKPOINT = 768
let currentPage = 1
let currentCategory = 'all'
let isGridAnimating = false

function isMobile() {
	return window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`).matches
}

function getFilteredCards() {
	return Array.from(ourTeamMemberCards).filter(card => {
		return currentCategory === 'all' || card.dataset.category.includes(currentCategory)
	})
}

function getTotalPages() {
	return Math.ceil(getFilteredCards().length / ITEMS_PER_PAGE)
}

function updateVisibleCards() {
	const filteredCards = getFilteredCards()
	const startIndex = (currentPage - 1) * ITEMS_PER_PAGE
	const endIndex = startIndex + ITEMS_PER_PAGE
	
	ourTeamMemberCards.forEach(card => {
		card.classList.remove('active')
	})
	
	filteredCards.forEach((card, index) => {
		if (index >= startIndex && index < endIndex) {
			card.classList.add('active')
		}
	})
}

function createPagination() {
	const existingPagination = ourTeamGallery.querySelector('.pagination-container')
	if (existingPagination) existingPagination.remove()
	
	const totalPages = getTotalPages()
	if (totalPages <= 1) return
	
	const paginationContainer = document.createElement('nav')
	paginationContainer.className = 'pagination-container'
	paginationContainer.setAttribute('aria-label', 'Team members pagination')
	paginationContainer.setAttribute('role', 'navigation')
	
	const paginationList = document.createElement('ul')
	paginationList.className = 'pagination-list'
	paginationList.setAttribute('role', 'list')
	
	// Previous button
	const prevItem = document.createElement('li')
	const prevButton = document.createElement('button')
	prevButton.className = 'pagination-btn pagination-prev'
	prevButton.setAttribute('aria-label', 'Go to previous page')
	prevButton.disabled = currentPage === 1
	prevButton.innerHTML = '<span aria-hidden="true">&larr;</span><span class="sr-only">Previous</span>'
	prevButton.addEventListener('click', () => goToPage(currentPage - 1))
	prevItem.appendChild(prevButton)
	paginationList.appendChild(prevItem)
	
	// Page numbers
	const pageNumbers = getPageNumbers(totalPages)
	pageNumbers.forEach(pageNum => {
		const pageItem = document.createElement('li')
		
		if (pageNum === '...') {
			const ellipsis = document.createElement('span')
			ellipsis.className = 'pagination-ellipsis'
			ellipsis.setAttribute('aria-hidden', 'true')
			ellipsis.textContent = '...'
			pageItem.appendChild(ellipsis)
		} else {
			const pageButton = document.createElement('button')
			pageButton.className = `pagination-btn pagination-number${pageNum === currentPage ? ' active' : ''}`
			pageButton.setAttribute('aria-label', `Page ${pageNum}`)
			pageButton.setAttribute('aria-current', pageNum === currentPage ? 'page' : 'false')
			pageButton.textContent = pageNum
			pageButton.addEventListener('click', () => goToPage(pageNum))
			pageItem.appendChild(pageButton)
		}
		
		paginationList.appendChild(pageItem)
	})
	
	// Next button
	const nextItem = document.createElement('li')
	const nextButton = document.createElement('button')
	nextButton.className = 'pagination-btn pagination-next'
	nextButton.setAttribute('aria-label', 'Go to next page')
	nextButton.disabled = currentPage === totalPages
	nextButton.innerHTML = '<span class="sr-only">Next</span><span aria-hidden="true">&rarr;</span>'
	nextButton.addEventListener('click', () => goToPage(currentPage + 1))
	nextItem.appendChild(nextButton)
	paginationList.appendChild(nextItem)
	
	paginationContainer.appendChild(paginationList)
	
	// Status for screen readers
	const liveRegion = document.createElement('div')
	liveRegion.className = 'pagination-status sr-only'
	liveRegion.setAttribute('aria-live', 'polite')
	liveRegion.setAttribute('aria-atomic', 'true')
	paginationContainer.appendChild(liveRegion)
	
	ourTeamGallery.appendChild(paginationContainer)
}

function getPageNumbers(totalPages) {
	const pages = []
	const maxVisible = isMobile() ? 3 : 5

	if (isMobile()) {
		if (totalPages <= 3) {
			for (let i = 1; i <= totalPages; i++) pages.push(i)
		} else {
			let start = Math.max(1, currentPage - 1)
			let end = Math.min(totalPages, currentPage + 1)
			if (end - start < 2) {
				if (start === 1) end = Math.min(3, totalPages)
				else start = Math.max(1, totalPages - 2)
			}
			for (let i = start; i <= end; i++) pages.push(i)
		}
		return pages
	}

	if (totalPages <= maxVisible + 2) {
		for (let i = 1; i <= totalPages; i++) pages.push(i)
	} else {
		pages.push(1)
		
		if (currentPage <= 3) {
			for (let i = 2; i <= 4; i++) pages.push(i)
			pages.push('...')
		} else if (currentPage >= totalPages - 2) {
			pages.push('...')
			for (let i = totalPages - 3; i < totalPages; i++) pages.push(i)
		} else {
			pages.push('...')
			for (let i = currentPage - 1; i <= currentPage + 1; i++) pages.push(i)
			pages.push('...')
		}
		
		pages.push(totalPages)
	}
	
	return pages
}

function goToPage(page) {
	if (isGridAnimating || page < 1 || page > getTotalPages() || page === currentPage) return
	
	isGridAnimating = true
	const startHeight = ourTeamGalleryContainer.offsetHeight
	ourTeamGalleryContainer.style.height = `${startHeight}px`
	ourTeamGalleryContainer.classList.add('fading-out')
	
	setTimeout(() => {
		currentPage = page
		updateVisibleCards()
		
		ourTeamGalleryContainer.style.height = 'auto'
		const endHeight = ourTeamGalleryContainer.offsetHeight
		ourTeamGalleryContainer.style.height = `${startHeight}px`
		ourTeamGalleryContainer.offsetHeight
		ourTeamGalleryContainer.style.height = `${endHeight}px`
		
		ourTeamGalleryContainer.classList.remove('fading-out')
		ourTeamGalleryContainer.classList.add('fading-in')
		
		createPagination()
		updatePaginationStatus()
		
		// Scroll to gallery top for better UX
		ourTeamGallery.scrollIntoView({ behavior: 'smooth', block: 'start' })
		
		setTimeout(() => {
			ourTeamGalleryContainer.classList.remove('fading-in')
			ourTeamGalleryContainer.style.height = ''
			isGridAnimating = false
			ScrollTrigger.refresh()
		}, 300)
	}, 300)
}

function updatePaginationStatus() {
	const status = ourTeamGallery.querySelector('.pagination-status')
	if (status) {
		const filteredCards = getFilteredCards()
		const startItem = (currentPage - 1) * ITEMS_PER_PAGE + 1
		const endItem = Math.min(currentPage * ITEMS_PER_PAGE, filteredCards.length)
		status.textContent = `Showing ${startItem} to ${endItem} of ${filteredCards.length} team members`
	}
}

if (ourTeamGalleryContainer) {
	// Initialize pagination
	updateVisibleCards()
	createPagination()
	
	ourTeamCategoryButtons.forEach(button => {
		button.addEventListener('click', () => {
			if (isGridAnimating) return
			
			const newCategory = button.dataset.category
			const currentActiveButton = document.querySelector('.our-team-gallery .category-button.active')
			if (currentActiveButton === button) return
			
			ourTeamCategoryButtons.forEach(btn => btn.classList.remove('active'))
			button.classList.add('active')
			
			isGridAnimating = true
			
			const startHeight = ourTeamGalleryContainer.offsetHeight
			ourTeamGalleryContainer.style.height = `${startHeight}px`
			ourTeamGalleryContainer.classList.add('fading-out')
			
			setTimeout(() => {
				currentCategory = newCategory
				currentPage = 1
				updateVisibleCards()
				
				ourTeamGalleryContainer.style.height = 'auto'
				const endHeight = ourTeamGalleryContainer.offsetHeight
				ourTeamGalleryContainer.style.height = `${startHeight}px`
				ourTeamGalleryContainer.offsetHeight
				ourTeamGalleryContainer.style.height = `${endHeight}px`
				
				ourTeamGalleryContainer.classList.remove('fading-out')
				ourTeamGalleryContainer.classList.add('fading-in')
				
				createPagination()
				updatePaginationStatus()
				
			setTimeout(() => {
				ourTeamGalleryContainer.classList.remove('fading-in')
				ourTeamGalleryContainer.style.height = ''
				isGridAnimating = false
				ScrollTrigger.refresh()
			}, 300)
		}, 300)
	})
})
}